import React, { memo } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import hex2rgba from '../../../services/colorUtils/hex2rgba';
import PrimaryActionDescriptionSection from './PrimaryActionDescriptionSection';
import PrimaryActionHeaderSection from './PrimaryActionHeaderSection';

const PrimaryAction = memo(({ action, index }) => {
  const theme = useTheme();
  const layoutOption = action?.imagePosition || 'left';
  const actionTitle = action?.actionTitle;
  const actionBody = action?.actionBody;
  const actionImage = action?.image?.url;

  const renderResources = (resources) =>
    resources?.map((r, index) => (
      <div key={index}>
        {r.fields.url?.href ? (
          <a
            href={r.fields.url.href}
            title={r.fields.title}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            {r.fields.title}
          </a>
        ) : (
          <span>{r.fields.title}</span>
        )}
      </div>
    ));

  return (
    <Box
      sx={[{
        padding: '1rem'
      }, index % 2 === 0 ? {
        backgroundColor: hex2rgba(action?.backgroundColor || '#BFB8AF', '0.15')
      } : {
        backgroundColor: null
      }, index === 0 ? {
        paddingTop: {
          lg: '4rem'
        }
      } : {
        paddingTop: {
          lg: '2rem'
        }
      }]}
    >
      <PrimaryActionHeaderSection
        actionImage={actionImage}
        actionTitle={actionTitle}
        actionBody={actionBody}
        theme={theme}
        layoutOption={layoutOption}
      />
      <PrimaryActionDescriptionSection
        action={action}
        renderResources={renderResources}
      />
    </Box>
  );
});

PrimaryAction.displayName = 'PrimaryAction';
export default PrimaryAction;
